const getApiBaseUrl = () => {
    if (typeof process === 'undefined') return '';

    const fromEnv = process.env.REACT_APP_API_URL;
    if (fromEnv && fromEnv.trim().length > 0) {
        return fromEnv.replace(/\/$/, '');
    }

    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:3002';
    }

    return '';
};

export default getApiBaseUrl;
